import { mergePatch } from '@kit/sync/merge/merge-patch';
import { replica } from '@/shared/sync/replica';
import type { CollectionName } from './collection-name';
import type { RecordSchema } from './record-schema';
import { validateRecord } from './validate-record';

/** Change a few fields (null removes one) without touching the rest. */
export async function patchRecord(
  collection: CollectionName,
  schema: RecordSchema,
  id: string,
  patch: Readonly<Record<string, unknown>>,
): Promise<void> {
  const current = await replica.get(id);
  if (!current) throw new Error('The record no longer exists');
  validateRecord(schema, mergePatch(current.data, patch));
  await replica.mutate(collection, 'upsert', { ...patch }, id);
}
